/**
 * Email theme – single source of truth for email colors and layout.
 * Use getEmailTheme() when rendering; later it can accept tenantId for per-tenant branding.
 */

export interface EmailTheme {
  /** Header area background (light shade so logo stays readable). */
  headerBackground: string;
  /** Header headline (h1) text color. */
  headerTextColor: string;
  /** Primary brand color: buttons, links, accents. */
  primary: string;
  /** Slightly darker primary for hover states. */
  primaryHover: string;
  /** Accent border and highlight box left border. */
  accentBorder: string;
  /** Footer logo/link color. */
  footerLink: string;
  /** Body text. */
  bodyText: string;
  /** Muted/secondary text. */
  mutedText: string;
  /** Page background (outside container). */
  pageBackground: string;
  /** Content area background. */
  contentBackground: string;
  /** Footer background. */
  footerBackground: string;
}

/** Default enterprise-ready theme: light header, navy accents. */
export const DEFAULT_EMAIL_THEME: EmailTheme = {
  headerBackground: '#f1f5f9',       // Light slate – logo readable, enterprise look
  headerTextColor: '#1e3a8a',        // Navy blue for header headline
  primary: '#1e3a8a',
  primaryHover: '#172554',
  accentBorder: '#1e3a8a',
  footerLink: '#1e3a8a',
  bodyText: '#333333',
  mutedText: '#6b7280',
  pageBackground: '#f5f5f5',
  contentBackground: '#ffffff',
  footerBackground: '#f9fafb',
};

/**
 * Resolve theme. Today returns the default theme.
 * Later: accept tenantId and look up tenant.featureFlags or tenant.branding, merge over DEFAULT_EMAIL_THEME.
 */
export function getEmailTheme(): EmailTheme {
  // TODO: when adding per-tenant branding, add (tenantId?: string) and fetch tenant + merge theme
  return DEFAULT_EMAIL_THEME;
}
